// src/services/gatePassService.ts
import api from "../lib/api.ts";

export const downloadGatePassPdf = async (
  gatePassId: number
): Promise<Blob> => {
  const response = await api.get(
    `/gatepasses/buyer/${gatePassId}/pdf/download`,
    {
      responseType: "blob",
      timeout: 60000, // 60 seconds
    }
  );
  return response.data;
};

export const streamGatePassPdf = async (gatePassId: number): Promise<Blob> => {
  const response = await api.get(`/gatepasses/buyer/${gatePassId}/pdf/stream`, {
    responseType: "blob",
       timeout: 60000, // 60 seconds

  });
  return response.data;
};

export const getBuyerGatePasses = async (buyerId: number, params: any) => {
  const response = await api.get(`/gatepasses/buyer/${buyerId}`, { params });
  return response.data;
};

export const getSellerGatePasses = async (sellerId: number, params: any) => {
  const response = await api.get(`/gatepasses/seller/${sellerId}`, { params });
  return response.data;
};
